import {Component} from '@angular/core';
import {environment} from '../environments/environment';

@Component({
    selector: 'mt-root',
    template: `
    <div class="app-wrapper mat-app-background">
      <router-outlet></router-outlet>
      <mt-loader #loader></mt-loader>
    </div>`,
    standalone: false
})
export class AppComponent {
  constructor() {
    document.title = environment.platformTitle;
    document.getElementById('appFavicon').setAttribute('href', environment.faviconUrl);
    
    // Apply theme colors from environment
    if (environment.theme) {
      // Set primary color based on environment
      const primaryColor = environment.theme.primaryPalette === 'blue' ? '#2563eb' : '#dc2626';
      document.documentElement.style.setProperty('--primary-color', primaryColor);
      
      // Set gradient colors
      document.documentElement.style.setProperty('--gradient-start', environment.theme.gradientStart);
      document.documentElement.style.setProperty('--gradient-end', environment.theme.gradientEnd);
    }
  }
}
